module.exports = __webpack_public_path__ + "static/media/fb-ok.a6c18a75.svg";